// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button_3KuHQ","medium":"Button_medium_2Ai9z","wide":"Button_wide_3Do_a","tall":"Button_tall_xKd-y","small":"Button_small_2mEVk"};